/* eslint react/prop-types: 0 */
import React from 'react';
import { Link } from 'react-router-dom';
import ViewHelpers from '@/shared/ViewHelpers';

import Label from '../../ui/label';

// TODO define ItemComponent interface

export default class List extends React.PureComponent {
  renderItems() {
    const { property, ItemComponent } = this.props;
    return (
      <React.Fragment>
        {property.subProperties.map(subProperty => (
          <div key={subProperty.name}>
            <Label style={{ display: 'inline' }}>{`${subProperty.label}: `}</Label>
            <ItemComponent
              {...this.props}
              key={subProperty.name}
              property={{ ...subProperty, name: `${property.name}.${subProperty.name}` }}
            />
          </div>
        ))}
      </React.Fragment>
    );
  }

  render() {
    const { property, record, resource } = this.props;
    const showAction = record.recordActions.find(a => a.name === 'show');

    if (resource.titleProperty.name === property.name && showAction) {
      const h = new ViewHelpers();
      const href = h.recordActionUrl({
        resourceId: resource.id, recordId: record.id, actionName: 'show',
      });
      return (
        <Link to={href}>{this.renderItems()}</Link>
      );
    }
    return this.renderItems();
  }
}
